export enum DatabaseOperationEnum {
        Add = 1,
        Edit = 2,
        Delete = 3,
        List = 4,
        Full = 15,
}
